<div class="header-search-container" (focusin)="onContainerFocusIn()" (click)="onContainerFocusIn()" (keydown)="onContainerFocusIn()">
  <app-searchbar [(searchString)]="currentSearchString" (searchStringChange)="onSearchInputChange($event)" />

  @if (showResults()) {
    <app-header-search-results (closeSearchResults)="onCloseSearch()" />
  }
</div>
